var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2482 2.32159C12.6006 3.44493 13.8781 3.97357 14.9207 3.43025C16.558 2.57856 18.3201 4.34068 17.4684 5.97797C16.9251 7.02056 17.4537 8.29809 18.5771 8.65051C20.3392 9.20852 20.3392 11.6975 18.5771 12.2482C17.4537 12.6006 16.9251 13.8781 17.4684 14.9207C18.3201 16.558 16.558 18.3201 14.9207 17.4684C13.8781 16.9251 12.6006 17.4537 12.2482 18.5771C11.6902 20.3392 9.20117 20.3392 8.65051 18.5771C8.29809 17.4537 7.02056 16.9251 5.97797 17.4684C4.34068 18.3201 2.57856 16.558 3.43025 14.9207C3.97357 13.8781 3.44493 12.6006 2.32159 12.2482C0.559471 11.6902 0.559471 9.20117 2.32159 8.65051C3.44493 8.29809 3.97357 7.02056 3.43025 5.97797C2.57856 4.34068 4.34068 2.57856 5.97797 3.43025C7.02056 3.97357 8.29809 3.44493 8.65051 2.32159C9.20852 0.559471 11.6975 0.559471 12.2482 2.32159Z",
    stroke: "#171717",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.0705 7.82812L7.82825 13.0704",
    stroke: "#171717",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.21003 9.23793C8.77772 9.23793 9.23793 8.77772 9.23793 8.21003C9.23793 7.64234 8.77772 7.18213 8.21003 7.18213C7.64234 7.18213 7.18213 7.64234 7.18213 8.21003C7.18213 8.77772 7.64234 9.23793 8.21003 9.23793Z",
    stroke: "#171717",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.6813 13.7094C13.249 13.7094 13.7092 13.2492 13.7092 12.6815C13.7092 12.1138 13.249 11.6536 12.6813 11.6536C12.1136 11.6536 11.6534 12.1138 11.6534 12.6815C11.6534 13.2492 12.1136 13.7094 12.6813 13.7094Z",
    stroke: "#171717",
    strokeLinejoin: "bevel"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvent);
export default __webpack_public_path__ + "static/media/icon_event.78db98eafb54828fe887e03cc0756df0.svg";
export { ForwardRef as ReactComponent };